<div class="sub-nav">
	@if (title || parentTitle) {
		<div class="sub-nav-header" [class.sub-nav-header--standalone]="!hasTabs">
			<h3 class="header-title">
				@if (parentTitle) {
					<button
						type="button"
						class="header-title-parent"
						data-automation-id="sub-nav-parent-title"
						(click)="parentTitleClick.emit()"
					>
						{{ parentTitle }}
					</button>
					<span class="header-title-separator" aria-hidden="true">→</span>
				}
				@if (title) {
					<span [class.header-title-current]="!!parentTitle" data-automation-id="sub-nav-title">{{ title }}</span>
				}
			</h3>
		</div>
	}
	@if (hasTabs) {
		<mat-tab-group
			class="sub-nav-tabs"
			appQueryStringTabGroup
			appTabAutomationId
			[queryParamKey]="queryParamKey!"
			[syncUrl]="syncUrl"
			[mat-stretch-tabs]="false"
			mat-align-tabs="start"
			(selectedIndexChange)="selectedIndexChange.emit($event)"
		>
			@for (tab of tabs; track tab) {
				<mat-tab [label]="tab.label" [attr.data-automation-id]="tab.automationId">
					<ng-template matTabContent>
						<ng-container [ngTemplateOutlet]="tab.templateRef" />
					</ng-template>
				</mat-tab>
			}
		</mat-tab-group>
	} @else {
		<div class="sub-nav-body">
			<ng-content></ng-content>
		</div>
	}
</div>
